import AuthSplitLayout from 'layouts/AuthSplitLayout';
import bg from 'assets/img/spot-illustrations/dark_1.jpg';
import SignOutForm from 'components/modules/auth/SignOutForm';

const SignOut = () => {
  return (
    <AuthSplitLayout bg={bg} logo={true}>
      <SignOutForm layout="split" />
    </AuthSplitLayout>
  );
};

export default SignOut;
